import { breakpoints } from '@bnnvara/breakpoints';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { defaultProps, propTypes } from '../props';
import useColor from '../useColor';
const Icon = styled.svg`
  width: 32px;
  height: 28px;
  transform: translate(-3px, -2px);

  ${breakpoints.md} {
    display: ${({
  responsive
}) => responsive && 'none'};
  }
`;

const SmallLogo = ({
  color,
  responsive
}) => {
  const iconColor = useColor(color);
  return /*#__PURE__*/React.createElement(Icon, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385.5 436.5",
    "aria-label": "BNNVARA-icoon",
    key: "small-logo",
    responsive: responsive
  }, /*#__PURE__*/React.createElement("rect", {
    x: "9.2",
    y: "144.5",
    transform: "matrix(0.9986 -5.233583e-02 5.233583e-02 0.9986 -9.6643 10.1411)",
    fill: "#E60000",
    width: "359.3",
    height: "90.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2.1",
    y: "9.3",
    transform: "matrix(0.9986 -5.233619e-02 5.233619e-02 0.9986 -2.601 9.5864)",
    fill: "#E60000",
    width: "359.3",
    height: "90.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16.2",
    y: "279.6",
    transform: "matrix(0.9986 -5.233585e-02 5.233585e-02 0.9986 -16.7276 10.6959)",
    fill: "#E60000",
    width: "359.3",
    height: "90.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M143.5,422.6c-0.1-3.4-0.8-4.1-4.1-4l-5.2,0.3l0.4,8.5l5.2-0.3C142.9,426.8,143.6,426.1,143.5,422.6 M138.7,405 l-5.2,0.3l0.4,7.1l5.4-0.3c2.4-0.1,3.2-0.7,3.1-3.7C142.1,405.6,141.2,404.9,138.7,405 M154.8,424.3c0.4,7.5-3.5,9.6-12.6,10.2 c-8.6,0.4-13,0.6-18.1,0.6l-1.8-36.2c4.7-0.6,8.6-0.8,16.4-1.3c10-0.6,14,1.3,14.4,8.8c0.3,5.1-2,7.6-7.5,8.3v0.8 C152.1,415.5,154.5,418.7,154.8,424.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M158.2,400.8c-0.1-2.5,1.1-4,3.7-4.1l4.7-0.3c2.4-0.1,3,0.8,4.5,3.1l8.2,11.4c1.4,2.1,2.5,4.7,3.5,7.5l1-0.3 c-0.6-2.5-1-5.4-1.1-7.8l-0.8-14.7l10.3-0.6l1.7,32.2c0.1,2.5-1.1,4-3.7,4.1l-4.7,0.3c-2.4,0.1-3.2-1.1-4.5-3.1l-8.3-12.1 c-1.6-2.4-2.3-4.8-3.1-7.5l-1,0.3c0.6,2.5,0.8,5.5,1,7.9l0.8,15.3L160,433L158.2,400.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M198.3,398.8c-0.1-2.5,1.1-4,3.7-4.1l4.7-0.3c2.4-0.1,3.1,0.8,4.5,3.1l8.2,11.4c1.4,2.1,2.5,4.7,3.5,7.5l1-0.3 c-0.6-2.5-1-5.4-1.1-7.8l-0.8-14.7l10.3-0.6l1.7,32.2c0.1,2.5-1.1,4-3.7,4.1l-4.7,0.3c-2.4,0.1-3.2-1.1-4.5-3.1l-8.3-12.1 c-1.6-2.4-2.3-4.8-3.1-7.5l-1,0.3c0.6,2.5,0.8,5.5,1,7.9l0.8,15.3l-10.3,0.6L198.3,398.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M263.9,424.5c-0.4,1.8-1.8,3.1-3.7,3.2l-10,0.6c-2,0.1-3.5-1-4.1-2.8l-10.7-32.6l11.7-0.6l6.1,23.2 c0.3,1.3,0.6,2.8,0.8,4.1h1.3c0.1-1.3,0.3-2.8,0.4-4.2l3.7-23.7l11.7-0.6L263.9,424.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M292,411.7l-2.5-9c-0.3-1.4-0.8-3.1-1-4.7l-1.7,0.1c-0.1,1.4-0.3,3.2-0.4,4.7l-1.6,9.2L292,411.7z M294.2,419 l-10.9,0.6l-1.3,7.1l-11.6,0.6l7.6-33.6c0.4-1.8,1.8-3,3.7-3.1l10.9-0.6c1.8-0.1,3.4,1,4,2.7l11.2,32.6l-11.6,0.6L294.2,419z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M329,399.4c-0.1-3.2-1.1-4.1-4.5-4l-4.2,0.3l0.4,8.3l4.2-0.3C328.3,403.5,329.2,402.6,329,399.4 M343.2,423.4 l-11.9,0.6l-3-10.6c-0.6-1.7-1.3-2.4-3.4-2.3l-3.8,0.1l0.7,13.1l-11.2,0.6l-1.8-36.2c4.9-0.7,8.2-1,15.5-1.3 c10.7-0.6,15.5,1.6,16,9.3c0.3,4.4-1.7,8.3-8.3,9.3v0.8c2.5,0.4,6.2,1.1,7.6,5.4L343.2,423.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconColor,
    d: "M367.3,407.7l-2.5-9c-0.3-1.4-0.8-3.1-1-4.7l-1.7,0.1c-0.1,1.4-0.3,3.2-0.4,4.7l-1.6,9.2L367.3,407.7z M369.4,415.1l-10.9,0.6l-1.3,7.1l-11.6,0.6l7.6-33.6c0.4-1.8,1.8-3,3.7-3.1l10.9-0.6c1.8-0.1,3.4,1,4,2.7l11.2,32.6l-11.6,0.6 L369.4,415.1z"
  }));
};

SmallLogo.propTypes = { ...propTypes,
  responsive: PropTypes.bool
};
SmallLogo.defaultProps = { ...defaultProps,
  responsive: false
};
export default SmallLogo;